export default {
  diffusionInputs: 'Diffusion inputs',
};
